import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';

import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
// import { Link } from "react-router-dom";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
// import { ITemplate } from "src/api/types";
import { ITemplateAdminPageProps } from "./IAdminPageProps";
import { FILE_URL } from "src/constants";
// import FileUploadModal from "src/shared/components/fileUploadModal";
import LoadingSpinner from 'src/shared/components/LoadingSpinner';
import 'src/features/admin/pages/home.css';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ITemplateAdminPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplatesPageState {
  getAllVideoData?: any;
  modalVisible: boolean;
  loader: boolean;
}

export default withStyles(styles)(
  withAxios(
    class UploadVideoPage extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
        getAllVideoData: [],
        loader: false
      });

      public componentDidMount() {
        // this.props.loadTemplates();
        this.getAllVideoHandler()
      }

      public async getAllVideoHandler() {
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, "video/getAllVideo")()
        console.log("USERRESPO=====>", res)
        if (res.status && res?.data?.length > 0) {
          const data = res.data.sort((a: any, b: any) => a.id - b.id);
          this.setState({ getAllVideoData: data })
          this.setState({ loader: false })
        } else {
          this.setState({ loader: false })
        }
        // this.setState({ user: res })
      }


      public async uploadVideoToServer({ file, item, onPress }: any) {
        this.setState({ loader: true })
        const data = new FormData();
        data.append('image', file);

        const res: any = await this.buildPut(
          this,
          `video/uploadVideo/${item?.id}`
        )(data);
        console.log("res=====>", res)
        if (res.status) {
          if (Object.keys(res.data).length > 0) {
            const array = this.state.getAllVideoData
            const index = array.findIndex((item: any) => item.id === res.data.id);

            if (index !== -1) {
              array[index] = res.data;
            }
            this.setState({ getAllVideoData: array })
            setTimeout(() => {
              this.getAllVideoHandler()
              // console.log("loader==========>2")
              onPress()
            }, 2000)
          }
        } else {
          alert("Please try again")
        }



      }
      public capitalizeWords(str:any) {
        return str.replace(/\b\w/g, (char:any) => char.toUpperCase());
      }
      
      public render() {

        return (
          <>
            {this.state.loader &&<div className="loader-bg-color">
              <LoadingSpinner /></div>}
            <Page header="Upload Video">

              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow className='table-rows'>
                      <TableCell>#</TableCell>
                      <TableCell>Source</TableCell>
                      <TableCell>Type</TableCell>
                      {/* <TableCell>Action</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.getAllVideoData?.map((row: any) => (
                      <TableRow key={row.id} className='table-even'>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>
                          <div>
                            <video width="150" controls={true} autoPlay={true}>
                              <source src={`${FILE_URL}/${row.file}`} type="video/mp4"  />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </TableCell>
                        <TableCell>{this.capitalizeWords(row.description)}</TableCell>
                        {/* <TableCell><FileUploadModal item={row} onUpload={(file: any) => {
                          console.log("File=========>", file)
                          this.uploadVideoToServer(file)
                        }}
                          loader={this.state.loader} /></TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

            </Page>
          
          </>
        );
      }



    }
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/pages/UploadVideoPage.tsx